module.exports = __webpack_public_path__ + "img/icon-property-sell.bb3ae377.svg";